"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setProps = exports.skipPropKeys = void 0;
var constants_1 = require("../constants");
exports.skipPropKeys = ['input'];
/**
 * Sets game object props.
 *
 * @param gameObject - Phaser game object.
 * @param props - Element props.
 * @param scene - Phaser scene.
 */
function setProps(gameObject, props, scene) {
    for (var key in props) {
        if (exports.skipPropKeys.indexOf(key) !== -1) {
            continue;
        }
        var value = props[key];
        if (value && key === 'data') {
            gameObject.setData(value);
            continue;
        }
        if (constants_1.events[key] && typeof value === 'function') {
            gameObject.setInteractive(props.input);
            gameObject.on(key.slice(2).toLowerCase(), value, scene);
            continue;
        }
        if (key in gameObject) {
            gameObject[key] = value;
            continue;
        }
    }
    if ((typeof props.originX === 'number' || typeof props.originY === 'number') &&
        typeof gameObject.setOrigin === 'function') {
        gameObject.setOrigin(props.originX, props.originY);
    }
}
exports.setProps = setProps;
//# sourceMappingURL=props.js.map